var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCheckSeaglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1426 6.37491C19.6259 6.86788 19.6181 7.65929 19.1251 8.14259L10.1213 16.9698L5.40797 12.6738C4.89775 12.2088 4.86113 11.4182 5.32617 10.908C5.79122 10.3977 6.58183 10.3611 7.09205 10.8262L10.0587 13.5302L17.3749 6.35741C17.8679 5.87411 18.6593 5.88195 19.1426 6.37491Z",
    fill: "#6D79FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckSeaglass);
export default __webpack_public_path__ + "static/media/icn-check-seaglass.9509746f4160ee1f9686dc78fdb0dfe6.svg";
export { ForwardRef as ReactComponent };